import tw from "tailwind-styled-components"


export const Text = tw.p`
mt-1 
hover:cursor-pointer 
transition  
hover:text-green 
duration-200 
hover:text-semibold 
w-[8rem]  
py-1 
ml-2 
flex 
items-center
text-blue-600

`